import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { AuthService } from './auth.service';
import { AutoLogoutService } from '../services/autoLogout.service';
import { SessionBootstrapService } from '../services/session-bootstrap.service';
import { SessionCacheHydrationService } from '../services/session-cache-hydration.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private autoLogoutService: AutoLogoutService,
    private sessionCacheHydration: SessionCacheHydrationService,
    private sessionBootstrap: SessionBootstrapService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (this.sessionBootstrap.isActive()) {
      if (this.authService.hasRestorableSession()) {
        this.autoLogoutService.setupAutoLogout();
        return true;
      }
      return this.router.createUrlTree(['/login']);
    }

    if (!this.sessionCacheHydration.isHydrated()) {
      return this.router.createUrlTree(['/login']);
    }

    const token = this.authService.getToken();
    if (!token || !this.authService.hasRestorableSession()) {
      return this.router.createUrlTree(['/login']);
    }

    if (
      !this.authService.getIsOTPVerified() &&
      !(token && this.authService.hasRestorableSession())
    ) {
      return this.router.createUrlTree(['/login']);
    }

    const expectedRole = next.data['role'];
    const userRole = Number(
      this.authService.getUserDetailsFromStorage()?.userRole
    );

    if (expectedRole && !expectedRole.includes(userRole)) {
      return this.router.createUrlTree(['/login']);
    }

    this.authService.setLastVisitedRoute(state.url);
    this.autoLogoutService.setupAutoLogout();
    return true;
  }
}
